export default __webpack_public_path__ + "static/media/download.a7fc0215.svg";